import { __rest as e } from "tslib";
import * as a from "react";
import i from "classnames";
import { classNameModifierByFlag as t, classNameModifier as o } from "../shared/utils.js";
import { ComponentClassNames as s } from "../shared/constants.js";
import { Flex as d } from "../Flex/Flex.js";
import { Input as r } from "../Input/Input.js";
import { Text as l } from "../Text/Text.js";
import { useRadioGroupContext as n } from "../RadioGroupField/context.js";
const m = (m, p) => {
    var {
        children: c,
        className: h,
        id: u,
        isDisabled: b,
        testId: f,
        value: R,
        labelPosition: g,
        height: v,
        width: j,
        bottom: N,
        left: x,
        position: E,
        padding: I,
        right: y,
        top: w
      } = m,
      D = e(m, ["children", "className", "id", "isDisabled", "testId", "value", "labelPosition", "height", "width", "bottom", "left", "position", "padding", "right", "top"]);
    const {
        currentValue: C,
        defaultValue: F,
        name: O,
        hasError: P,
        isGroupDisabled: V,
        isRequired: k,
        isReadOnly: q,
        onChange: z,
        size: B,
        labelPosition: G
      } = n(),
      T = V || b || q && F !== R,
      H = void 0 !== C ? R === C : void 0,
      L = void 0 !== F ? R === F : void 0,
      A = g || G;
    return a.createElement(d, {
      as: "label",
      className: i(s.Radio, t(s.Radio, "disabled", T), h),
      "data-disabled": T,
      "data-label-position": A,
      width: j,
      bottom: N,
      top: w,
      right: y,
      left: x,
      position: E,
      padding: I
    }, c && a.createElement(l, {
      as: "span",
      className: s.RadioLabel,
      "data-disabled": T
    }, c), a.createElement(r, Object.assign({
      checked: H,
      className: i(s.VisuallyHidden, s.RadioInput),
      defaultChecked: L,
      hasError: P,
      id: u,
      isDisabled: T,
      isReadOnly: q,
      isRequired: k,
      onChange: z,
      ref: p,
      type: "radio",
      name: O,
      value: R
    }, D)), a.createElement(d, {
      "aria-hidden": "true",
      as: "span",
      className: i(s.RadioButton, o(s.RadioButton, B)),
      "data-size": B,
      testId: f
    }));
  },
  p = a.forwardRef(m);
p.displayName = "Radio";
export { p as Radio, m as RadioPrimitive };